import { AfterViewInit, Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { ActivatedRoute, Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { BlockUI, NgBlockUI } from 'ng-block-ui';
import { ToastrService } from 'ngx-toastr';
import { BehaviorSubject, interval, Subscription } from 'rxjs';
import { takeWhile } from 'rxjs/operators';
import { AuthService } from 'src/app/core/auth/auth.service';
import { Message } from 'src/app/core/class/message';
import { ErrorCode } from 'src/app/core/constants/error-code';
import { HyperLink } from 'src/app/core/constants/hyperlink';
import { SCREEN_SIZE } from 'src/app/core/constants/screen-size';
import { AnonymousSignService } from 'src/app/core/services/anonymous-sign.service';
import { AuthenticationService } from 'src/app/core/services/authentication.service';
import { CommonService } from 'src/app/core/services/common.service';
import { ConnectiveLoginService } from 'src/app/core/services/connective-login.service';
import { NotificationCmsService } from 'src/app/core/services/notification-cms.service';
import { NotificationService } from 'src/app/core/services/notification.service';
import { ResponsiveService } from 'src/app/core/services/responsive.service';
import { LoginBase } from '../../../login-base';
import { AnonymousCloudCaComponent } from '../anonymous-cloud-ca/anonymous-cloud-ca.component';

@Component({
  selector: 'app-anonymous-two-factor-authen',
  templateUrl: './anonymous-two-factor-authen.component.html',
  styleUrls: ['./anonymous-two-factor-authen.component.scss'],
})

export class AnonymousTwoFactorAuthenComponent extends LoginBase implements OnInit, OnDestroy, AfterViewInit {
  @BlockUI() blockUI: NgBlockUI;
  currentLanguage = 'vi';
  timeSign: number = 0;
  selectedCertCloudCa: any;
  isShowTimeLine: boolean = false;
  subscriptions: Subscription = new Subscription();
  tenantId: string = '';
  countdown$ = new BehaviorSubject<number | null>(null); // Đếm ngược
  signingInteval: any;
  timeSignProcessing: number = 0;
  @Output() confirmSendRequest = new EventEmitter<boolean>();
  @Output() changeMode = new EventEmitter<string>();
  @Input() isAnonymousLogin: boolean = false;
  private countdownSub: Subscription | null = null; // Lưu subscription của interval
  public phoneNumber: string = '';
  public mediaBreakpoint: any;
  public subscribeMediaBreakPointService: Subscription;
  constructor(
    private router: Router,
    private authService: AuthenticationService,
    private authSer: AuthService,
    private notificationService: NotificationService,
    private dialogRef: MatDialog,
    private message: Message,
    private translate: TranslateService,
    public commonService: CommonService,
    private activeRouter: ActivatedRoute,
    public dialog: MatDialog,
    private connectiveLoginService: ConnectiveLoginService,
    public notificationCmsService: NotificationCmsService,
    public toastService: ToastrService,
    private anonymousSignService: AnonymousSignService,
    private responsiveService: ResponsiveService
  ) {
    super();
    this.phoneNumber = HyperLink.PHONE_NUMBER;
  }

  ngOnInit() {
    this.currentLanguage = localStorage.getItem('__language');
    this.tenantId = sessionStorage.getItem('tenantId');
    if (!this.tenantId) {
      this.tenantId = localStorage.getItem('tenantId');
    }
    if (!this.currentLanguage) {
      this.currentLanguage = 'vi';
    }
    this.subscribeData();
    
  }
  subscribeData() {
    this.subscriptions.add(
      this.anonymousSignService.timeWaitSign.asObservable().subscribe(res => {
        if (res) {
          this.timeSign = res;
        }
      })
    );
    this.subscriptions.add(
      this.anonymousSignService.selectedCert.asObservable().subscribe(res => {
        if (res) {
          this.selectedCertCloudCa = res;
        }
      })
    );
  }

  /**
   * On destroy component
   */
  ngOnDestroy() {
    this.notificationService.unsubscribeErrorService();
    this.subscribeMediaBreakPointService.unsubscribe();
  }

  onSendRequest() {
    this.isShowTimeLine = true;
    this.countdown$.next(this.timeSign);
    this.countdownSub = interval(1000)
    .pipe(takeWhile((v) => v < this.timeSign))
    .subscribe({
      next: (value) => this.countdown$.next(this.timeSign - value - 1),
      complete: () => this.resetButton(),
    });
    let body;
    if (this.isAnonymousLogin) {
      body = {
        tenantId: this.tenantId,
        serialNumber: this.selectedCertCloudCa.serialNumber,
        providerName: this.selectedCertCloudCa.cloudCaProviderName,
        credentialId: this.selectedCertCloudCa.credentialId,
        cloudCaUserId: this.selectedCertCloudCa.cloudCaUserId,
        hashKey: sessionStorage.getItem('hashKey') ? sessionStorage.getItem('hashKey') : '',
        actionType: localStorage.getItem('actionType') ? localStorage.getItem('actionType') : '',
        transactionId: this.commonService.generateUUID()
      }
      this.anonymousSignService.sendRequest(body).subscribe(
        res => {
          if (res.success) {
            this.timeSignProcessing = 0;
            this.signingProcess(body.transactionId);
          } else {
            if (res.code === ErrorCode.CLOUD_CA_EXPIRED) {
              this.changeMode.emit('LOGIN');
            } 
            this.toastService.error(res.message);
            this.isShowTimeLine = false;
            this.clearCountdown();
          }
          // if (res.success) {
          //   this.confirmSendRequest.emit(true);
          // } else {
          //   if (res.code === ErrorCode.CLOUD_CA_EXPIRED) {
          //     this.changeMode.emit('LOGIN');
          //   } 
          //   this.toastService.error(res.message);
          // }
          // this.isShowTimeLine = false;
          // this.clearCountdown();
        }
      )
    } else {
       body = {
        tenantId: this.tenantId,
        serialNumber: this.selectedCertCloudCa.serialNumber,
        providerName: this.selectedCertCloudCa.cloudCaProviderName,
        credentialId: this.selectedCertCloudCa.credentialId,
        cloudCaUserId: this.selectedCertCloudCa.cloudCaUserId,
        transactionId: this.commonService.generateUUID()
      }
      this.authService.sendRequest(body).subscribe(
        res => {
          if (res.success) {
            this.timeSignProcessing = 0;
            this.signingProcess(body.transactionId);
          } else {
            if (res.code === ErrorCode.CLOUD_CA_EXPIRED) {
              this.changeMode.emit('LOGIN');
            } 
            this.toastService.error(res.message);
            this.isShowTimeLine = false;
            this.clearCountdown();
          }
          // if (res.success) {
          //   this.confirmSendRequest.emit(true);
          // } else {
          //   if (res.code === ErrorCode.CLOUD_CA_EXPIRED) {
          //     this.changeMode.emit('LOGIN');
          //   } 
          //   this.toastService.error(res.message);
          // }
          // this.isShowTimeLine = false;
          // this.clearCountdown();
        }
      )
    }
  }

  signingProcess(signTransactionId: string) {
    this.signingInteval = setInterval(() => {
      this.authService.getResultSigning(signTransactionId).subscribe(rs => {
        if (rs && rs.success && !rs.data) {
          clearInterval(this.signingInteval);
          this.confirmSendRequest.emit(true);
          this.isShowTimeLine = false;
          this.clearCountdown();
        } else if (rs && rs.success && rs.data && rs.data == 'PROCESSING') {
          this.timeSignProcessing = this.timeSignProcessing + 3;
          if (this.timeSignProcessing > this.timeSign) {
            clearInterval(this.signingInteval);
            this.isShowTimeLine = false;
            this.clearCountdown();
          }
        } else {
          if (rs.code === ErrorCode.CLOUD_CA_EXPIRED) {
            this.changeMode.emit('LOGIN');
          } 
          this.toastService.error(rs.message);
          clearInterval(this.signingInteval);
          this.isShowTimeLine = false;
          this.clearCountdown();
        }
      })
    }, 3000)
  }

   // Dừng bộ đếm ngược và enable button
   private clearCountdown() {
    if (this.countdownSub) {
      this.countdownSub.unsubscribe(); // Hủy interval
    }
    this.resetButton();
  }

  // Reset trạng thái button
  private resetButton() {
    this.isShowTimeLine = false;
    this.countdown$.next(null); // Ẩn đếm ngược
  }

   // Hàm chuyển đổi từ giây sang định dạng MM:SS
   formatTime(seconds: number): string {
    const minutes = Math.floor(seconds / 60);
    const remainingSeconds = seconds % 60;
    return `${minutes}:${remainingSeconds.toString().padStart(2, '0')}s`;
  }

  ngAfterViewInit() {
    setTimeout(() => {
      this.dialog.closeAll();
    }, 1000);
    this.subscribeMediaBreakPointService = this.responsiveService._getMediaBreakpoint().subscribe(
      media => {
        if (media === '') {
          this.mediaBreakpoint = '';
          return;
        } else {
          this.mediaBreakpoint = media;
        }
      }
    );
  }

  /**
   * Method name: onChangeLanguage
   */
  onChangeLanguage(languageSelected: string) {
    this.currentLanguage = languageSelected;

    // start waiting.
    this.blockUI.reset();
    this.blockUI.start('');
    this.onCheckBlockUI();

    this.setLanguagelocalStored(languageSelected);
    this.translate.use(this.getLanguagelocalStored());
    this.checkIconLanguage(this.getLanguagelocalStored());
    this.blockUI.stop();
  }

  /**
   * Check block UI.
   */
  private onCheckBlockUI() {
    localStorage.setItem('blockUI', '1');
    const timerId = setInterval(() => {
      if (localStorage.getItem('blockUI') == '0') {
        this.blockUI.stop();
        clearInterval(timerId);
        localStorage.removeItem('blockUI');
      }
    }, 1000);
  }

  changeCert() {
    const dialogRe = this.dialog.open(AnonymousCloudCaComponent, {
      width: this.mediaBreakpoint === SCREEN_SIZE.XS || this.mediaBreakpoint === SCREEN_SIZE.SM ? '100%' : this.mediaBreakpoint === SCREEN_SIZE.MD || this.mediaBreakpoint === SCREEN_SIZE.LG ? '80%' : '80%',
      maxWidth: this.mediaBreakpoint === SCREEN_SIZE.XS || this.mediaBreakpoint === SCREEN_SIZE.SM ? '100vw' : this.mediaBreakpoint === SCREEN_SIZE.MD || this.mediaBreakpoint === SCREEN_SIZE.LG ? '90vw' : '80vw',
      panelClass: 'scontract-overlay-dialog',
      data: true,
      disableClose: true,
      maxHeight: '90vh'
    });
    dialogRe.afterClosed().subscribe(data => {
      console.log(data);
    })
  }
  maskNumber(value: string , visibleDigits: number = 3): string {
    const strValue = value ? value.toString() : '';
    if (strValue.length <= visibleDigits) {
      return strValue; 
    }
    const maskedPart = '*'.repeat(strValue.length - visibleDigits);
    return maskedPart + strValue.slice(-visibleDigits);
  }

  getCurrentNameLanguage(): string{
    switch(this.currentLanguage){
      case 'vi':
        return 'Tiếng Việt';
      case 'en':
        return 'English';
      case 'zh':
        return '中国人';
      case 'es':
        return 'Español';
      default:
        return 'Tiếng Việt'
    }
  }
  isOpen: boolean = false;
}
